"use strict";
module.exports = require("./FileUpload.vue");
